import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import { ChevronLeft } from 'lucide-react';
import Button from '../Shared/Button';
import courses from "../../assets/Courses.jpg"
import training from "../../assets/Training.jpg"
import consulting from "../../assets/Consultation.jpg"
import { Link } from 'react-router-dom';

const slidesData = [
    {
        id: 1,
        title: 'Provide High End Courses!',
        description: 'Our courses are designed with real-world applications in mind, providing practical knowledge and skills that empower you to excel in your career and adapt to industry demands.',
        image: courses,
        link: '/courses',
    },
    {
        id: 2,
        title: 'Provide Specific Trainings!',
        description: 'Our training programs are expertly designed to provide hands-on learning experiences, ensuring that you acquire practical skills and knowledge that can be immediately applied in your professional environment.',
        image: training,    
        link: '/training',
    },
    {
        id: 3,
        title: 'Provide Expert Consultations!',
        description: 'Our consultations offer personalized strategies and expert insights tailored to your specific challenges, helping you achieve measurable results and drive meaningful change in your organization.',
        image: consulting,
        link: '/consultation',
    },
];

const HeroSection = () => {
    return (
        <div className='h-[600px] relative md:mt-20 mt-[60px]'>
            <div className="md:block flex md:justify-between justify-end sm:gap-4 gap-2 mx-auto items-center w-full md:static absolute md:bottom-0 bottom-4 z-[9999999] px-2.5">
                <button className="custom-prev2 z-50 md:absolute md:top-1/2 md:-translate-y-1/2  hover:bg-secondary transition-all duration-300 bg-black/35 text-white flex items-center justify-center sm:size-[60px] size-10">
                    <ChevronLeft className='sm:w-auto w-7' size={40} />
                </button>
                <button className="custom-next2 z-50 md:absolute md:top-1/2 md:-translate-y-1/2 right-3 hover:bg-secondary transition-all duration-300 bg-black/35 text-white flex items-center justify-center sm:size-[60px] size-10">
                    <ChevronLeft className="rotate-180 sm:w-auto w-7" size={40} />
                </button>
            </div>

            <Swiper
                                grabCursor={true}
                navigation={{
                    nextEl: ".custom-next2",
                    prevEl: ".custom-prev2",
                }}
                loop={true}
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                }} 
                modules={[Autoplay,  Navigation]}
                speed={3000}
            className="mySwiper">
                {slidesData.map(slide => (
                    <SwiperSlide key={slide.id} className='relative'>
                        <div className='relative'>
                            <img src={slide.image} className='h-[600px] w-full relative object-cover' alt="" />
                            <div className='w-full h-full absolute inset-0 z-10 bg-[#010101]/50' />
                        </div>
                        <div className='max-w-[1140px] mx-auto'>
                            <div className='absolute z-50 top-1/2 -translate-y-1/2 md:space-y-8 space-y-4 text-white max-w-[515px] px-4'>
                                <h1 className='font-semibold lg:text-[55px] md:text-5xl sm:text-4xl text-3xl leading-none'>{slide.title}</h1>
                                <p className='sm:text-base text-sm'>{slide.description}</p>
                                <Link to={slide.link}>
                                <Button variant='primary' className='w-[156px] mt-4 sm:!h-[55px] !h-12 sm:!text-base !text-sm relative '>Learn More</Button>
                                </Link>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}

export default HeroSection;
